<template>
  <AdChart :options="chartOptions" />
</template>

<script>
import cloneDeep from 'lodash.clonedeep';

import AdChart from '@@/advertisement/common/AdChart';

export default {
  name: 'CampaignOverallChart',
  components: {
    AdChart,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    secondYAxis: {
      type: String,
      default: null,
    },
    yAxis: {
      type: String,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartSeries() {
      if (!this.series || !this.series.length) return [];
      if (this.secondYAxis) {
        const series = cloneDeep(this.series);
        series[1].yAxis = 1;
        return series;
      }
      return this.series;
    },
    chartOptions() {
      const options = {
        xAxis: {
          categories: this.categories,
        },
        series: this.chartSeries,
        yAxis: [
          {
            title: {
              text: this.yAxis,
            },
          },
        ],
      };
      if (this.secondYAxis) {
        options.yAxis.push({
          title: {
            text: this.secondYAxis,
          },
          opposite: true,
        });
      }

      return options;
    },
  },
};
</script>
